import { render, staticRenderFns } from "./TireModelForm.vue?vue&type=template&id=4467fac5&scoped=true&lang=pug"
import script from "./TireModelForm.vue?vue&type=script&lang=js"
export * from "./TireModelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467fac5",
  null
  
)

export default component.exports